import type { IconData } from '@stacksjs/iconify-core'

export const waterDropF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M7 .565q7 9.135 7 13a7 7 0 1 1-14 0q0-3.865 7-13\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default waterDropF
